module.exports = __webpack_public_path__ + "static/media/social-instagram.43070b59.svg";